import { useQuery } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { getData } from '@/utils/getData';

export const useGetShippingOptions = (countryCode: string) => {
  const { data } = useQuery({
    enabled: Boolean(countryCode),
    queryFn: getData(Endpoint.GetShippingOptions, { countryCode }),
    queryKey: [QueryKey.ShippingOptions, { countryCode }],
  });

  return data?.data;
};
